module.exports = __webpack_public_path__ + "img/sql_connect.d83a70b6.svg";